import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { Row } from 'components/UI/Row';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { updateProfile, ProfileUpdate, getProfile } from './profiles';

const UpdateProfileSchema = object().shape({
  company_name: string(),
  first_name: string().required('errors.first is required'),
  last_name: string().required('errors.last name is required'),
  tax_code: string().required('errors.tax code is required'),
  address: string().required('errors.address is required'),
  city: string().required('errors.city is required'),
  postal_code: string().required('errors.zip code is required'),
  phone_number: string().required('errors.phone number is required')
});

const ProfileEdit: FC<{ setEditProfile: (newVal: boolean) => void }> = ({ setEditProfile }) => {
  const dispatch = useDispatch();
  const profile = useSelector(getProfile);

  const { handleSubmit, errors, control, setValue } = useForm<ProfileUpdate>({
    mode: 'onBlur',
    resolver: yupResolver(UpdateProfileSchema)
  });

  useEffect(() => {
    if (profile) {
      const { address, company_name, first_name, last_name, tax_code, city, postal_code, phone_number } = profile;
      setValue('company_name', company_name);
      setValue('first_name', first_name);
      setValue('last_name', last_name);
      setValue('tax_code', tax_code);
      setValue('address', address);
      setValue('city', city);
      setValue('postal_code', postal_code);
      setValue('phone_number', phone_number);
    }
  }, [profile, setValue]);

  const onSubmit = async (formData: ProfileUpdate) => {
    await dispatch(updateProfile(formData));
    setEditProfile(false);
    // manage errors
  };
  const { t } = useTranslation();

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}
      >
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'first_name.message'))}
                error={!isEmpty(get(errors, `first_name`))}
                label={t('label.first name')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="first_name"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'last_name.message'))}
                error={!isEmpty(get(errors, `last_name`))}
                label={t('label.last name')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="last_name"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'company_name.message'))}
                error={!isEmpty(get(errors, `company_name`))}
                label={t('label.company name')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="company_name"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'tax_code.message'))}
                error={!isEmpty(get(errors, `tax_code`))}
                label={t('label.tax_code')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="tax_code"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'address.message'))}
                error={!isEmpty(get(errors, `address`))}
                label={t('label.address')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="address"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'city.message'))}
                error={!isEmpty(get(errors, `city`))}
                label={t('label.city')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="city"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'postal_code.message'))}
                error={!isEmpty(get(errors, `postal_code`))}
                label={t('label.zip code')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="postal_code"
          />
        </Row>
        <Row>
          <Controller
            as={
              <TextField
                autoComplete="new-password"
                helperText={t(get(errors, 'phone_number.message'))}
                error={!isEmpty(get(errors, `phone_number`))}
                label={t('label.phone number')}
                type="text"
                style={{ marginBottom: '16px', width: '400px' }}
                variant="outlined"
              />
            }
            control={control}
            defaultValue=""
            name="phone_number"
          />
        </Row>
        <Button type="submit" color="primary">
          {t('label.save')}
        </Button>
      </form>
    </>
  );
};
export { ProfileEdit };
